
export namespace NewCurriculum {
    export class Load {
        static readonly type = '[NewCurriculum] Load';
    }
}